export default () => ({
  tooltip: {
    fontSize: 12,
    fontWeight: 400,
    maxWidth: 320,
  },
  arrow: {
    fontSize: 12,
  },
});
